<template>
<div>
    <table class="table">
        <tr>
            <th>
                Tytuł
                <sorting @change-order="changeOrder" :sort="meta.sort" :key-for="'title'" :direction="meta.direction"></sorting>

            </th>

            <th>
                Status
                <sorting @change-order="changeOrder" :sort="meta.sort" :key-for="'status'" :direction="meta.direction"></sorting>

            </th>

            <th>
                Utworzono
                <sorting @change-order="changeOrder" :sort="meta.sort" :key-for="'created_at'" :direction="meta.direction"></sorting>

            </th>
            <th>
                Adresaci
            </th>
            <th>
                Akcje
            </th>
        </tr>
        <tr v-for="item in items">
            <td>
                <a class="main-link" @click="$router.push({name: 'admin.messages.show', params: {id: item.id}})">{{ item.title }}</a>
            </td>

            <td>
                <message-status :status="item.status"></message-status>
            </td>
            <td>
                {{ item.created_at_formated }}
            </td>

            <td>
                <p>
                    Wysyłka do:
                    <message-send-to-info :item="item"></message-send-to-info>
                </p>
                </p>

                <p>
                    W grupach: <a v-for="g in item.email_groups" @click="$router.push({name: 'admin.email-groups.show', params: {id: g.id}})" class="badge">{{ g.name }}</a>
                </p>
            </td>

            <td class="actions">
                <ui-button type="flat" icon="mode_edit" color="primary" @click.prevent="$router.push({name: 'admin.messages.edit', params: {id: item.id}})" :disabled="item.status!=1">Edytuj</ui-button>
                <ui-button type="flat" icon="highlight_off" color="danger" @click.prevent="remove(item)">Usuń</ui-button>
            </td>
        </tr>
    </table>
    <basic-pagination :meta="meta" @pagination-page="changePage" @pagination-limit="changeLimit"></basic-pagination>
</div>

</template>
<script>
import Messages from './../../services/Messages'
import EventEmitter from './../../services/EventEmitter'
import Loading from './../../mixins/Loading'
import Paginate from './../../mixins/Paginate'
import Notify from './../../mixins/Notify'

export default {
  mixins: [Loading, Paginate, Notify],
  methods: {
    getService () {
      return Messages
    },
    _remove (item) {
      Messages.remove(item.id).then(res => {
        if (res.status === 204) {
          this.reload()
          this.notify('Usunięto')
        }
      })
    },
    remove (item) {
      EventEmitter.$emit('confirm.show', {
        confirmCb: () => {
          this._remove(item)
        }
      })
    }
  },
  mounted () {
    EventEmitter.$on('messages.reload', () => {
      this.meta.current_page = 1
      this.reload()
    })
  }
  // ,
  // events: {
  //   'messages.reload': function () {
  //     this.meta.current_page = 1
  //     this.reload()
  //   }
  // }
}
</script>


// WEBPACK FOOTER //
// List.vue?0c786115